<script setup lang="ts">
const { isOnline } = useConnectivity();
</script>

<template>
  <v-alert
    v-if="!isOnline"
    type="warning"
    icon="mdi-wifi-off"
    variant="tonal"
    class="mb-0"
    :rounded="0"
  >
    You appear to be offline. Some features may not work until your connection
    is restored.
  </v-alert>
</template>
